// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__gJzS-","bigColWidth":"Table_bigColWidth__W0IRm","biggerColWidth":"Table_biggerColWidth__27Xat","row":"Table_row__Bp8hL","col":"Table_col__2tiEZ"};